import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { shipSelectOptionSchema } from "view/ships/utils/ship.schema";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";
import { ExistingCharterSchema } from "view/charters/utils/charter.schema";
import { InactivityType } from "__generated__/enums";
import { intl } from "LocaleWrapper";

export const inactivitySchema = z.object({
	type: z.enum(InactivityType),
	ship: ZodSchema.requiredField(shipSelectOptionSchema),
	purchaseCharter: ZodSchema.requiredField(ExistingCharterSchema),
	windowFrom: ZodSchema.requiredField(z.number()),
	windowTo: ZodSchema.requiredField(z.number()),
	location: ZodSchema.requiredField(locationSelectOptionSchema),
}).refine(data => data.windowFrom <= data.windowTo, {
	message: intl.formatMessage({ id: "INACTIVITY_WINDOW_TO_BEFORE_FROM" }),
	path: [ "windowTo" ],
	when(payload) {
		return inactivitySchema.pick({ windowFrom: true, windowTo: true }).safeParse(payload.value).success;
	},
});

export type InactivitySchemaInput = z.input<typeof inactivitySchema>;
export type InactivitySchemaOutput = z.output<typeof inactivitySchema>;
